"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createHighContrastTheme", {
    enumerable: true,
    get: function() {
        return createHighContrastTheme;
    }
});
const _highContrastColorPalette = require("../alias/highContrastColorPalette");
const _highContrastColor = require("../alias/highContrastColor");
const _index = require("../global/index");
const _shadows = require("./shadows");
const _durations = require("../global/durations");
const _curves = require("../global/curves");
const _spacings = require("../global/spacings");
const createHighContrastTheme = ()=>{
    const colorTokens = (0, _highContrastColor.generateColorTokens)();
    return {
        ..._index.borderRadius,
        ..._index.fontSizes,
        ..._index.lineHeights,
        ..._index.fontFamilies,
        ..._index.fontWeights,
        ..._index.strokeWidths,
        ..._spacings.horizontalSpacings,
        ..._spacings.verticalSpacings,
        ..._durations.durations,
        ..._curves.curves,
        ...colorTokens,
        ..._highContrastColorPalette.colorPaletteTokens,
        ..._highContrastColorPalette.colorStatusTokens,
        ...(0, _shadows.createShadowTokens)(colorTokens.colorNeutralShadowAmbient, colorTokens.colorNeutralShadowKey),
        ...(0, _shadows.createShadowTokens)(colorTokens.colorBrandShadowAmbient, colorTokens.colorBrandShadowKey, 'Brand')
    };
};
